<template>
  <div :class="[outerClass, outerClassRendering]" :style="inlineStyle" :data-test-id="dataTestId">
    <iframe
      v-if="iframeUrl"
      v-show="iframeLoaded"
      :src="embeddedPage"
      :title="embeddedPageTitle"
      :class="innerClass"
      :height="height"
      :width="width"
      @loadstart="iframeLoaded = false"
      @load="iframeLoaded = true"
    />
    <DotLottieVue
      v-if="!iframeLoaded && iframeUrl"
      autoplay
      class="absolute top-[50%] left-[50%] translate-y-[-50%] translate-x-[-50%]"
      style="width: 80px"
      loop
      :data="loadingIconData"
    />
  </div>
</template>
<script setup lang="ts">
import { DotLottieVue } from '@lottiefiles/dotlottie-vue';
import loadingData from '@/assets/animated-icons/Loading_spinner_blue.json';
import { ref } from 'vue';
import { ComponentFields, ComponentRendering, Field } from '@sitecore-jss/sitecore-jss-vue';
import { usePageStore } from '@/store';
import { useRoute } from 'vue-router';
import { stringify } from 'querystring';

const props = defineProps<{
  rendering: ComponentRendering;
  fields: ComponentFields;
}>();

// Forward query to iframe
const route = useRoute();
const queryString = stringify((route?.query as Record<string, string>) ?? {});
const iframeUrl = (props.fields.src as Field<string>)?.value;
const embeddedPage = ref<string>(`${iframeUrl}${iframeUrl?.includes('?') ? '&' : '?'}${queryString}`);

const loadingIconData = loadingData as any;
const embeddedPageTitle = ref<string>((props.fields.title as Field<string>)?.value);
const innerClass = ref<string>((props.fields.innerClass as Field<string>)?.value);
const outerClass = ref<string>((props.fields.outerClass as Field<string>)?.value);
const height = ref<number>((props.fields.height as Field<number>)?.value);
const width = ref<number>((props.fields.width as Field<number>)?.value);
const iframeLoaded = ref(false);

const outerClassRendering = props.rendering?.params?.Styles;
const inlineStyle = props.rendering?.params?.inlineStyle;
const dataTestId = usePageStore().dataTestId(props.rendering);
</script>
